import styled from 'styled-components'
import Img from 'gatsby-image'

import { customMedia } from '../../utils/breakpoints';

export const HomeBanner = styled.div`
  padding-top: 64px;
  padding-bottom: 35px;

  ${customMedia.greaterThan('lg')`
    max-width: 1366px;
    margin: 0 auto;
  `}

  .slick-dots.customDots {
    position: absolute;
    top: 105%;
    left: 0;
    text-align: center;
  }

  .slick-dots li.slick-active button:before {
    color: #323232;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: ${props => props.theme.colors.secondary};
  }

  @keyframes loading {
    from {
      width: 0%;
    }

    to {
      width: 100%;
    }
  }

  .ft-slick__dots--custom {
    height: 8px;
    width: 8px;
    background-color: #323232;
    border-radius: 4px;
    position: relative;
  }

  .slick-dots li {
    position: relative;
    display: inline-block;
    width: 14px;
    margin: 0 2px;
    transition: width 0.3s ease-in-out;
  }

  .slick-dots .slick-active {
    width: 24px;
    transition: width 0.3s ease-in-out;
  }

  .slick-dots .slick-active .ft-slick__dots--custom {
    width: 24px;
    top: 0px;
    background-color: #323232;

    .loading {
      height: 8px;
      animation: loading 10s ease-in;
      background-image: linear-gradient(270deg, ${props => props.theme.bannerHome.loadingDots}, ${props => props.theme.bannerHome.loadingDots});
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px;
    }
  }

`

export const Moldura = styled.div`
  height: auto;
  width: 100%;
  min-height: 100%;
  // overflow: hidden;
`


export const Banner1 = styled(Img)`
  height: 264px;
  
  ${customMedia.greaterThan('md')`
    height: 376px;
  `}
`